import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../custom.css';
import { faLocationArrow} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Logo from './images/logo2.png';
import Name from './images/register_icons/Name.png';
import Address from './images/register_icons/Address.png';
import City from './images/register_icons/City.png';
import Shop from './images/register_icons/Shop.png';
import GST from './images/register_icons/gst.png';

function Register() {
  const [formData, setFormData] = useState({
    mobileNumber: '',
    fullName: '',
    email: '',
    companyName: '',
    shopName: '',
    city: '',
    address: '',
  });
  
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const [isFetchingLocation, setIsFetchingLocation] = useState(false);
  const [showOTPVerification, setShowOTPVerification] = useState(false);
  const [otp, setOTP] = useState(['', '', '', '']);
  const [otpSent, setOtpSent] = useState(false);
  const [showOtpVerifiedPopup, setShowOtpVerifiedPopup] = useState(false);
const [isOtpVerified, setIsOtpVerified] = useState(false);
const [mobileError, setMobileError] = useState('');
const [isCheckingMobile, setIsCheckingMobile] = useState(false);
const [resendTimer, setResendTimer] = useState(30);
const [canResendOtp, setCanResendOtp] = useState(false);


  const navigate = useNavigate();
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;

  // Add this function to handle location fetching
const handleGetLocation = () => {
  if (!navigator.geolocation) {
    alert("Geolocation is not supported by your browser");
    return;
  }

  setIsFetchingLocation(true);
  
  // Method 1: Browser Geolocation
  navigator.geolocation.getCurrentPosition(
    async (position) => {
      const { latitude, longitude } = position.coords;
      console.log("Browser Geolocation:", latitude, longitude);

      // Method 2: Fallback to Google Maps Geolocation API
      try {
        const googleLocationResponse = await fetch(
          `https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyBRUP8Qe2tPjC8vExjseQ0t3YD9qp3Ok30`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        const googleLocationData = await googleLocationResponse.json();
        
        // Compare and choose most accurate location
        const googleLat = googleLocationData.location?.lat;
        const googleLng = googleLocationData.location?.lng;
        
        console.log("Google Geolocation:", googleLat, googleLng);

        // Choose the most accurate coordinates
        const finalLat = Math.abs(googleLat - latitude) < 0.001 ? googleLat : latitude;
        const finalLng = Math.abs(googleLng - longitude) < 0.001 ? googleLng : longitude;

        console.log("Final Coordinates:", finalLat, finalLng);

        // Proceed with geocoding using final coordinates
        const geocodingResponse = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${finalLat},${finalLng}&key=AIzaSyBRUP8Qe2tPjC8vExjseQ0t3YD9qp3Ok30`
        );
        
        const geocodingData = await geocodingResponse.json();
        
        if (geocodingData.results && geocodingData.results.length > 0) {
          const addressComponents = geocodingData.results[0].address_components;
          const formattedAddress = geocodingData.results[0].formatted_address;
          
          // Extract city from locality
          const locality = addressComponents.find(component => 
            component.types.includes('locality'))?.long_name || '';
          
          // Use the complete formatted address directly for full address display
          setFormData({
            ...formData,
            address: formattedAddress,
            city: locality
          });
        } else {
          alert("Could not determine address from your location");
        }
      } catch (error) {
        console.error("Location retrieval error:", error);
        alert("Error fetching location details");
      } finally {
        setIsFetchingLocation(false);
      }
    },
    (error) => {
      setIsFetchingLocation(false);
      switch(error.code) {
        case error.PERMISSION_DENIED:
          alert("User denied the request for Geolocation.");
          break;
        case error.POSITION_UNAVAILABLE:
          alert("Location information is unavailable.");
          break;
        case error.TIMEOUT:
          alert("The request to get user location timed out.");
          break;
        default:
          alert(`Error getting location: ${error.message}`);
      }
    },
    {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0
    }
  );
};

useEffect(() => {
  let interval = null;
  
  if (showOTPVerification && resendTimer > 0 && !canResendOtp) {
    interval = setInterval(() => {
      setResendTimer(timer => timer - 1);
      if (resendTimer <= 1) {
        setCanResendOtp(true);
      }
    }, 1000);
  }
  
  return () => {
    if (interval) clearInterval(interval);
  };
}, [showOTPVerification, resendTimer, canResendOtp]);


const handleResendOTP = () => {
  setResendTimer(30);
  setCanResendOtp(false);
  setOTP(['', '', '', '']);
  console.log('Resending OTP to:', formData.mobileNumber);
};


const checkMobileExists = async (mobileNumber) => {
  if (mobileNumber.length !== 10) {
    setMobileError('');
    return;
  }

  setIsCheckingMobile(true);
  try {
    const response = await fetch(`${fetchUrl}vendor/vendor-login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ mobile_number: mobileNumber })
    });

    const result = await response.json();
    
    // Check the response based on your existing vendor-login logic
    if (response.status === 200 && result._id) {
      // Vendor found with this mobile number
      setMobileError('Mobile number already exists');
    } else if (response.status === 404 || result.status === 404) {
      // Vendor not found - mobile number is available
      setMobileError('');
    } else if (response.status === 403 || result.status === 403) {
      // Vendor exists but account is inactive/not approved
      setMobileError('Mobile number already exists');
    } else {
      // Any other case, assume mobile is available
      setMobileError('');
    }
  } catch (error) {
    console.error('Error checking mobile number:', error);
    // On network error, don't block the user
    setMobileError('');
  } finally {
    setIsCheckingMobile(false);
  }
};





 // Updated handleInputChange function
const handleInputChange = (e) => {
  const { id, value } = e.target;
  
  if (id === 'mobileNumber') {
    const numericValue = value.replace(/\D/g, '');

    if (numericValue.length <= 10) {

        if (numericValue.length === 0 || /^[6-9]/.test(numericValue)) {
            setFormData({ ...formData, [id]: numericValue });

            if (mobileError) {
                setMobileError('');
            }

            if (numericValue.length === 10) {
                setTimeout(() => {
                    checkMobileExists(numericValue);
                }, 300);
            }
        } else {
            setMobileError('Mobile number must start with 6, 7, 8, or 9');
        }
    }


  } else if (id === 'gstNumber') {
    const upperValue = value.toUpperCase();
    setFormData(prev => {
      const newFormData = { ...prev, gstNumber: upperValue };
      // Auto-fill PAN from GST (first 10 characters) when GST is complete
      if (upperValue.length === 15) {
        newFormData.panNumber = upperValue.substring(0, 10);
      } else {
        // Clear PAN if GST is not complete
        newFormData.panNumber = '';
      }
      return newFormData;
    });
  } else {
    setFormData({ ...formData, [id]: value });
  }
};



// Updated validateForm function
const validateForm = () => {
  const errorMessages = [];
  
  // Check for mobile error first
  if (mobileError) {
    errorMessages.push(mobileError);
    return errorMessages;
  }
  
  // Validate mobile number
  if (!formData.mobileNumber) {
    errorMessages.push('Mobile number is required');
  } else if (formData.mobileNumber.length !== 10) {
    errorMessages.push('Please enter a valid 10-digit mobile number');
  }
  
  // Check if mobile number is verified
  if (formData.mobileNumber && !isOtpVerified) {
    errorMessages.push('Please verify your mobile number');
  }
  
  // Validate required fields
  if (!formData.fullName) {
    errorMessages.push('Full name is required');
  }
  
  if (!formData.shopName) {
    errorMessages.push('Shop name is required');
  }
  
  if (!formData.city) {
    errorMessages.push('City is required');
  }
  
  if (!formData.address) {
    errorMessages.push('Address is required');
  }
  
  // Validate GST Number (required field)
  if (!formData.gstNumber) {
    errorMessages.push('GST number is required');
  } else {
    const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (!gstinRegex.test(formData.gstNumber)) {
      errorMessages.push('Invalid GST format');
    }
  }
  
  // Validate email if provided
  if (formData.email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      errorMessages.push('Please enter a valid email address');
    }
  }
  
  // Validate PAN if provided
  // if (formData.panNumber) {
  //   const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  //   if (!panRegex.test(formData.panNumber)) {
  //     errorMessages.push('Invalid PAN format');
  //   }
  // }
  
  return errorMessages;
};




  const handleSubmit = async () => {
    const errorMessages = validateForm();
    
    if (errorMessages.length > 0) {
      alert(errorMessages.join('\n'));
      return;
    }
    
    setIsLoading(true);
    
    try {
      const saveUrl = `${fetchUrl}vendor/create-vendor`;
      
      // Prepare data similar to NewVendor.js format
      const requestData = {
        name: formData.fullName,
        company_name: formData.companyName || formData.shopName,
        mobile_number: formData.mobileNumber,
        email: formData.email,
        city: formData.city,
        address: formData.address,
        vendor_status: 1, // Self-registration status
        // Add empty fields that might be expected by backend
        state: '',
        bank_name: '',
        bank_IFSC: '',
        account_number: '',
        account_holder_name: '',
        pincode: '',
        vendorContacts: JSON.stringify([]), // Empty contacts array
        hubId: '', // You might need to set this based on your logic
      };
      if (formData.gstNumber) {
      console.log(formData.gstNumber);
      requestData.gstin = formData.gstNumber;
      // Send PAN derived from GST
      requestData.pan = formData.panNumber; // This will be set automatically
    }
      console.log(requestData);
      const formDataToSend = new FormData();
      Object.keys(requestData).forEach(key => {
        formDataToSend.append(key, requestData[key]);
      });

      const response = await fetch(saveUrl, {
        method: 'POST',
        body: formDataToSend
      });

      const responseData = await response.json();
      
      if (responseData.status === 200 || responseData.status === 201) {
        setPopupMessage('Registration successful! Your account is pending approval.');
        setPopupType('success');
        setShowPopup(true);
        
        // Reset form
        setFormData({
          mobileNumber: '',
          fullName: '',
          email: '',
          companyName: '',
          shopName: '',
          city: '',
          address: '',
          gstNumber: '',
          panNumber: ''
        });
        
        // Navigate to login after 3 seconds
        setTimeout(() => {
          setShowPopup(false);
          navigate('/supplier/login');
        }, 3000);
        
      } else if (responseData.status === 400) {
        console.log('Registration failed:', responseData.message);
        setPopupMessage(responseData.message || 'Registration failed. Please check your details.');
        setPopupType('error');
        setShowPopup(true);
      } else {
        setPopupMessage('Registration failed. Please try again.');
        setPopupType('error');
        setShowPopup(true);
      }
      
    } catch (error) {
      console.error('Registration error:', error);
      setPopupMessage('Network error. Please try again.');
      setPopupType('error');
      setShowPopup(true);
    } finally {
      setIsLoading(false);
    }
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className="flex flex-col min-h-screen bg-[#F0EFEF]">
      {/* Logo Section */}
      <div className="flex justify-center items-center pt-5 pb-8 flex-grow">
        <img
          src={Logo}
          alt="Company Logo"
          className="h-24 md:h-28"
        />
      </div>

      {/* Register Container */}
     <div className="bg-white rounded-t-3xl shadow-lg px-6 pt-6 pb-5 flex flex-col h-[80vh] overflow-hidden">
  {/* Register Header */}
  <h1 className="text-xl font-semibold text-black mb-4 text-center">
    Register
  </h1>

{mobileError && (
  <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
    <div className="flex items-center">
    
      <div className="ml-2">
        <p className="text-sm text-red-800 font-medium">
          {mobileError}
        </p>
      </div>
    </div>
  </div>
)}
  <div className="flex-grow overflow-y-auto no-scrollbar pr-2 mb-4">
  {/* Registration Form */}
  <div className="space-y-4 px-2"> {/* Added px-2 for consistent padding */}
    {/* Mobile Number Input */}
<div>
  <label htmlFor="mobileNumber" className="block text-md font-semibold text-[#524D4D] mb-2">
    Mobile Number *
  </label>
  
  <div className="flex relative">
    <div className="flex items-center justify-center px-3 border border-gray-300 border-r-0 rounded-l-md">
      <span className="text-[#A8A1A1] font-medium">+91</span>
    </div>
    <input
      type="tel"
      id="mobileNumber"
      value={formData.mobileNumber}
      onChange={handleInputChange}
      placeholder="Enter mobile number"
      className={`w-full px-4 py-3 border rounded-r-md focus:outline-none focus:ring-1 focus:border-transparent ${
        mobileError 
          ? 'border-red-500 focus:ring-red-500' 
          : 'border-gray-300 focus:ring-[#D64541]'
      }`}
      maxLength="10"
      required
    />
    
    {/* Loading indicator when checking mobile */}
    {/* {isCheckingMobile && (
      <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-[#D64541]"></div>
      </div>
    )} */}
    
    {/* Show green checkmark if mobile exists (already verified), otherwise show verify/verified states */}
    {!isCheckingMobile && isOtpVerified ? (
  // Show green checkmark only when OTP is verified
  <div className="absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center space-x-2">
    <div className="w-5 h-5 bg-green-600 rounded-full flex items-center justify-center">
      <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <span className="text-green-600 font-medium text-sm">VERIFIED</span>
  </div>
) : !isCheckingMobile && !otpSent && formData.mobileNumber.length === 10 && !mobileError ? (
  // Show VERIFY button when mobile is available
  <button
    type="button"
    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#D64541] hover:text-opacity-80 cursor-pointer font-medium text-sm focus:outline-none transition-all duration-300"
    onClick={() => {
      setShowOTPVerification(true);
      setOtpSent(true);
    }}
  >
    VERIFY
  </button>
) : !isCheckingMobile && otpSent && !isOtpVerified ? (
  // Show OTP SENT text
  <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#A8A1A1] font-medium text-sm">
    OTP SENT
  </span>
) : null}

  </div>

  {/* OTP Verification Section - Only show if OTP sent and not verified and no mobile error */}
  {showOTPVerification && !isOtpVerified && !mobileError && (
    <div className="mt-2">
      <div className="font-semibold text-sm text-[#A8A1A1]">
        Enter OTP
      </div>
      
      <div className="flex items-center space-x-4">
        {/* OTP Input Fields */}
        <div className="flex space-x-2">
          {[1, 2, 3, 4].map((index) => (
        <input
  key={index}
  type="text"
  inputMode="numeric"
  pattern="[0-9]*"
  maxLength="1"
  placeholder="0"
  className="w-12 h-12 text-center border-b-2 border-gray-300 focus:border-[#D64541] focus:outline-none text-xl"
  onChange={(e) => {
    // Allow digits only
    const digit = e.target.value.replace(/[^0-9]/g, "");

    const newOTP = [...otp];
    newOTP[index - 1] = digit;
    setOTP(newOTP);

    // Auto focus next box
    if (digit && e.target.nextSibling) {
      e.target.nextSibling.focus();
    }
  }}
  value={otp[index - 1] || ""}
/>

          ))}
        </div>

        {/* Verify OTP Button */}
        <button
          type="button"
          className={`text-xs px-2 py-2 rounded-md transition-all duration-300 ${
            otp.join('').length === 4
              ? 'bg-[#D64541] text-white hover:bg-opacity-90'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
          disabled={otp.join('').length !== 4}
          onClick={() => {
            const otpString = otp.join('');
            console.log('Verifying OTP:', otpString);
            
            // Hide OTP verification section
            setShowOTPVerification(false);
            // Mark OTP as verified
            setIsOtpVerified(true);
            // Show success popup
            setShowOtpVerifiedPopup(true);
            
            // Hide popup after 3 seconds
            setTimeout(() => {
              setShowOtpVerifiedPopup(false);
            }, 3000);
          }}
        >
          Verify OTP
        </button>
      </div>

      {/* Resend OTP Link */}
<div className="flex justify-end mt-2">
  {canResendOtp ? (
    <span
      className="text-sm text-[#D64541] cursor-pointe font-medium"
      onClick={handleResendOTP}
    >
      Resend OTP
    </span>
  ) : (
   <span className="text-sm text-gray-400">
      Resend OTP in <span className="text-[#D64541] font-medium">{resendTimer}</span>s
    </span>
  )}
</div>

    </div>
  )}
</div>

{/* Resend OTP Link with Timer */}




    {/* Full Name Input */}
    <div>
      <label htmlFor="fullName" className="block text-md font-semibold text-[#524D4D] mb-2">
        Name *
      </label>
      <div className="relative">
        <img 
          src={Name} 
          alt="Name Icon" 
          className="absolute left-1.5 top-1/2 transform -translate-y-1/2 w-8 h-6"
        />
        <input
          type="text"
          id="fullName"
          value={formData.fullName}
          onChange={handleInputChange}
          placeholder="Enter your full name"
          className="w-full pl-10 bg-[#F6F4F4] px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#D64541] focus:border-transparent"
          required
        />
      </div>
    </div>

    {/* Shop Name Input */}
    <div>
      <label htmlFor="shopName" className="block text-md font-semibold text-[#524D4D] mb-2">
        Name of your Business *
      </label>
      <div className="relative">
        <img 
          src={Shop} 
          alt="Shop Icon" 
          className="absolute left-2 top-1/2 transform -translate-y-1/2 w-7 h-5"
        />
        <input
          type="text"
          id="shopName"
          value={formData.shopName}
          onChange={handleInputChange}
          placeholder="Enter your business name"
          className="w-full pl-10 bg-[#F6F4F4] px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#D64541] focus:border-transparent"
          required
        />
      </div>
    </div>

    {/* GST Number Input */}
    <div>
  <label htmlFor="gstNumber" className="block text-md font-semibold text-[#524D4D] mb-2">
    GST Number *
  </label>
  <div className="relative">
    <img 
      src={GST}
      alt="GST Icon" 
      className="absolute left-2 top-1/2 transform -translate-y-1/2 w-6 h-5"
    />
    <input
        type="text"
      id="gstNumber"
      value={formData.gstNumber}
      onChange={handleInputChange}
      placeholder="Enter Business GSTIN"
      className="w-full pl-10 bg-[#F6F4F4] px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#D64541] focus:border-transparent"
      maxLength="15"
      required
    />
  </div>
</div>
{/* PAN Number Display (only show when GST is entered) */}
{formData.panNumber && (
  <div>
    <label className="block text-md font-semibold text-[#524D4D] mb-2">
      PAN Number
    </label>
    <div className="relative">
      <img 
        src={GST}
        alt="PAN Icon" 
        className="absolute left-2 top-1/2 transform -translate-y-1/2 w-6 h-5"
      />
      <div className="w-full pl-10 bg-[#F6F4F4] px-4 py-3 border border-gray-300 rounded-md text-gray-700">
        {formData.panNumber}
      </div>
    </div>
  </div>
)}
    {/* City Input */}
    <div>
      <label htmlFor="city" className="block text-md font-semibold text-[#524D4D] mb-2">
        City *
      </label>
      <div className="relative">
        <img 
          src={City} 
          alt="City Icon" 
          className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5"
        />
        <input
          type="text"
          id="city"
          value={formData.city}
          onChange={handleInputChange}
          placeholder="Enter City"
          className="w-full pl-10 bg-[#F6F4F4] px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#D64541] focus:border-transparent"
          required
        />
      </div>
    </div>

    {/* Address Input */}
    <div>
  <label htmlFor="address" className="block text-md font-semibold text-[#524D4D] mb-2">
   Business Address *
  </label>
  <div className="relative">
    <img 
      src={Address} 
      alt="Address Icon" 
      className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5"
    />
    <input
      type="text"
      id="address"
      value={formData.address}
      onChange={handleInputChange}
      placeholder="Search Address"
      className="w-full pl-10 pr-10 bg-[#F6F4F4] px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#D64541] focus:border-transparent"
      required
    />
    <button
      type="button"
      onClick={handleGetLocation}
      disabled={isFetchingLocation}
      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-[#D64541] focus:outline-none"
      title="Get current location"
    >
      {isFetchingLocation ? (
        <svg className="animate-spin h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      ) : (
        <FontAwesomeIcon icon={faLocationArrow} className="text-blue-500 h-5 w-5" />
      )}
    </button>
  </div>
</div>
  </div>
</div>

        {/* Submit Button */}
       <div className="sticky bottom-0 left-0 right-0 bg-white pt-4 pb-2 border-t border-gray-200">
    {/* Submit Button */}
    <button
      onClick={handleSubmit}
      disabled={isLoading}
      className={`w-full py-3 rounded-md font-medium transition duration-300 mb-2 ${
        isLoading 
          ? 'bg-gray-400 text-gray-600 cursor-not-allowed' 
          : 'bg-[#D64541] text-white hover:bg-opacity-90'
      }`}
    >
      {isLoading ? 'Submitting...' : 'Submit'}
    </button>

    {/* Already have an account */}
    <div className="text-center">
      <p className="font-semibold text-[#827E7E]">
        Already have an account?{' '}
        <span
          className="text-[#D64541] font-medium cursor-pointer underline"
          onClick={() => navigate('/supplier/login')}
        >
          Login
        </span>
      </p>
    </div>
  </div>
</div>

      {/* Success/Error Popup */}
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 mx-4 max-w-sm w-full">
            <div className="text-center">
              {popupType === 'success' ? (
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
                  <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                  </svg>
                </div>
              ) : (
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
                  <svg className="h-6 w-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                  </svg>
                </div>
              )}
              
              <h3 className={`text-lg font-medium mb-2 ${popupType === 'success' ? 'text-green-800' : 'text-red-800'}`}>
                {popupType === 'success' ? 'Registration Successful!' : 'Registration Failed'}
              </h3>
              
              <p className="text-sm text-gray-600 mb-4">
                {popupMessage}
              </p>
              
              {popupType === 'error' && (
                <button
                  onClick={closePopup}
                  className="w-full bg-red-600 text-white py-2 px-4 rounded-md hover:bg-red-700 transition duration-300"
                >
                  Close
                </button>
              )}
              
              {popupType === 'success' && (
                <div className="text-sm text-gray-500">
                  Redirecting to login page...
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {showOtpVerifiedPopup && (
  <div className="fixed top-10 inset-x-0 z-50 flex justify-center px-4">
    <div className="bg-green-100 border border-green-300 rounded-lg px-8 py-2 shadow-lg flex items-center space-x-3 min-w-[280px]">
      {/* Success Icon with Circle */}
      <div className="flex-shrink-0">
        <div className="w-6 h-6 bg-green-600 rounded-full flex items-center justify-center">
          <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
          </svg>
        </div>
      </div>
      
      {/* Success Message */}
      <span className="text-green-800 font-semibold text-sm">
        Mobile number verified successfully!
      </span>
    </div>
  </div>
)}
    </div>
  );
}

export default Register;

